import { Injectable, OnDestroy } from '@angular/core';
import { Observable, BehaviorSubject, of, Subscription } from 'rxjs';
import { map, catchError, switchMap, finalize } from 'rxjs/operators';
import { UserModel } from '../_models/user.model';
import { AuthModel } from '../_models/auth.model';
import { AuthHTTPService, HttpServicsService } from './auth-http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import * as signalR from "@microsoft/signalr";
import { UserNotificationDto } from 'src/app/pages/notifications/_model/NotificationDto';

@Injectable({
  providedIn: 'root',
})
export class AuthService implements OnDestroy {
  // private fields
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  private authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`;
  private DbsToken = `${environment.appVersion}-Dbd`;
  // public fields
  currentUser$: Observable<UserModel>;
  isLoading$: Observable<boolean>;
  currentUserSubject: BehaviorSubject<UserModel>;
  isLoadingSubject: BehaviorSubject<boolean>;
  Dbs: BehaviorSubject<DbsForMenu>;
  public connection: signalR.HubConnection;
  get currentUserValue(): UserModel {
    return this.currentUserSubject.value;
  }

  set currentUserValue(user: UserModel) {
    this.currentUserSubject.next(user);
  }
  isconeccted: boolean = false;
  constructor(
    private authHttpService: AuthHTTPService,
    private router: Router,
    private HttpServicsServicesss: HttpServicsService
  ) {
    this.isLoadingSubject = new BehaviorSubject<boolean>(false);
    this.currentUserSubject = new BehaviorSubject<UserModel>(undefined);
    this.currentUser$ = this.currentUserSubject.asObservable();
    this.isLoading$ = this.isLoadingSubject.asObservable();
    const subscr = this.getUserByToken().subscribe();
    this.unsubscribe.push(subscr);

  }

  public connect() {
    const url = `${environment.imgUrl}/chatHub?token=${this.getAuthFromLocalStorage().access_token}`;
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(url)
      .withAutomaticReconnect([5000, 10000, 60000, 600000])
      .build();
    this.connection.start().then(() => {
      console.log('SignalR Connected');
    }).catch(err => {
      setTimeout(this.connect, 5000);
    });
    this.connection.onreconnected(async () => {
      console.log('reconnected');


    });

    this.connection.onclose(() => {
      console.log('Connecting ...');

    });

  }
  public getNotification() {
    return this.connection.on(`Notification`, (message: UserNotificationDto) => {

    });
  }
  public getRemoveNotification(): any {
    this.connection.on(`RemoveNotification`, (message) => {
      return message;
    });
  }
  public getWarning(): any {
    this.connection.on(`Warning`, (message) => {
      return message;
    });
  }
  public getRemoveWarning(): any {
    this.connection.on(`RemoveWarning`, (message) => {
      return message;
    });
  }

  // public methods
  login(email: string, password: string): Observable<UserModel> {
    this.isLoadingSubject.next(true);
    return this.authHttpService.login(email, password).pipe(
      map((auth: AuthModel) => {
        const result = this.setAuthFromLocalStorage(auth);
        this.dblistinitial();

        return result;
      }),
      switchMap(() => this.getUserByToken()),
      catchError((err) => {
        console.error('err', err);
        return of(undefined);
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );
  }
  dblistinitial() {
    this.cleardbstolocalstorage();
    this.HttpServicsServicesss.getDbManager().subscribe(res => {
      var adddbs: DbsForMenu[] = [{ name: "سال جاری", IsCelected: true, DId: "" }]
      res.data.forEach(element => {
        adddbs.push({
          DId: element.tId,
          IsCelected: false,
          name: element.name
        })
      });

      this.setdbstolocalstorage(adddbs);

    });
  }
  logout() {
    localStorage.removeItem(this.authLocalStorageToken);
    localStorage.removeItem(this.DbsToken);
    this.router.navigate(['/auth/login'], {
      queryParams: {},
    });
  }

  getUserByToken(): Observable<UserModel> {
    const auth = this.getAuthFromLocalStorage();
    if (!auth || !auth.access_token) {
      return of(undefined);
    }

    this.isLoadingSubject.next(true);
    try {
      return this.authHttpService.getUserByToken(auth.access_token).pipe(
        map((user: UserModel) => {
  
          if (user) {
            this.currentUserSubject = new BehaviorSubject<UserModel>(user);
  
          } else {
            this.logout();
          }
          return user;
        }),
        
        finalize(() => this.isLoadingSubject.next(false))
      );
    }catch{
      this.logout();
    }
    
  }

  // need create new user then login
  registration(user: UserModel): Observable<any> {
    this.isLoadingSubject.next(true);
    return this.authHttpService.createUser(user).pipe(
      map(() => {
        this.isLoadingSubject.next(false);
      }),
      switchMap(() => this.login(user.email, user.password)),
      catchError((err) => {
        console.error('err', err);
        return of(undefined);
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );
  }

  forgotPassword(email: string): Observable<boolean> {
    this.isLoadingSubject.next(true);
    return this.authHttpService
      .forgotPassword(email)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }
  cleardbstolocalstorage() {
    if (this.getDbsFromLocalStorage()) {
      localStorage.removeItem(this.DbsToken);
      return true;
    }

  }
  setdbstolocalstorage(dbs: DbsForMenu[]) {
    if (dbs) {
      localStorage.setItem(this.DbsToken, JSON.stringify(dbs));
      return true;
    }
    return false;
  }
  getDbsFromLocalStorage(): DbsForMenu[] {
    try {
      const authData = JSON.parse(
        localStorage.getItem(this.DbsToken)
      );
      return authData;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }

  // private methods
  private setAuthFromLocalStorage(auth: AuthModel): boolean {
    // store auth authToken/refreshToken/epiresIn in local storage to keep user logged in between page refreshes
    if (auth && auth.access_token) {
      localStorage.setItem(this.authLocalStorageToken, JSON.stringify(auth));
      return true;
    }
    return false;
  }

  private getAuthFromLocalStorage(): AuthModel {
    try {
      const authData = JSON.parse(
        localStorage.getItem(this.authLocalStorageToken)
      );
      return authData;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}

export class DbsForMenu {
  name: string;
  DId: string;
  IsCelected: boolean;
}